import { axiosAction } from "../../utils/axiosAction";
import { constructSearchObj } from "../../utils/utils";
import {
  REGIONS_CLEAR_COUNTRIES,
  REGIONS_FETCH_CATEGORY,
  REGIONS_FETCH_COUNTRIES,
  REGIONS_FETCH_GLOBAL_COUNTRIES,
  REGIONS_FETCH_REGIONS,
  REGIONS_FETCH_STATES
} from "../action-types/regions";

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_REGIONS}`;
const ENDPOINT_REGION_CATEGORY = `${process.env.REACT_APP_ENDPOINT_REGION_CATEGORIES}`;

export const clearEntities = () => ({
  type: REGIONS_CLEAR_COUNTRIES,
});

export const getEntities = () => async dispatch => {
  return axiosAction.get(ENDPOINT, REGIONS_FETCH_REGIONS, dispatch);
};

export const getRegions =
  (params = {}, meta?) =>
  async dispatch => {
    return axiosAction.get(
      `${ENDPOINT}${constructSearchObj(params)}`,
      REGIONS_FETCH_REGIONS,
      dispatch,
    );
  };

export const getCountries =
  (region, params = {}) =>
  async dispatch => {
    return axiosAction.get(
      `${ENDPOINT}/${region}/countries${constructSearchObj(params)}`,
      REGIONS_FETCH_COUNTRIES,
      dispatch,
      { meta: { region } },
    );
  };

export const getStates = (regionId, countryId) => async dispatch => {
  return axiosAction.get(
    `${ENDPOINT}/${regionId}/countries/${countryId}/states`,
    REGIONS_FETCH_STATES,
    dispatch,
    { meta: { country: countryId } },
  );
};

export const getGlobalCountries = () => async dispatch => {
  return axiosAction.get(
    `${ENDPOINT}/GLOBAL/countries`,
    REGIONS_FETCH_GLOBAL_COUNTRIES,
    dispatch,
  );
};

export const getRegionCategory = (commodityId, region) => async dispatch => {
  return axiosAction.get(
    `${ENDPOINT_REGION_CATEGORY}/commodities/${commodityId}?region=${region}`,
    REGIONS_FETCH_CATEGORY,
    dispatch,
    {
      meta: { region },
    },
  );
};
